/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {generateDraftUI} from '../api'

export const useMutationGenerateDraftUI = createReactQueryMutationHook('generateDraftUI', generateDraftUI)
